// Module
var code = "<span class=\"filter-container\"> <dashboard-filter-item ng-repeat=\"filterItem in $ctrl.filterItems\" filter-item-data=\"filterItem\" is-selected=\"$ctrl.selectedFilterItem.name === filterItem.name\" on-select=\"$ctrl.select(filterItem)\"></dashboard-filter-item> </span> ";
// Exports
export default code;